module.exports = [
	{
		"href": "http://fastcashmoneyplus.biz",
		"description": "FastCashMoneyPlus.biz is the hottest fastcash accumulation platform on the web today."
	},
	{
		"href": "http://fastcashmoneyplus.biz",
		"description": "Be part of the new digital economy today! Don't get left behind"
	},
	{
		"href": "http://fastcashmoneyplus.biz",
		"description": "Don't miss out on the investment opportunity of a lifetime that professional investment experts don't want you to know about"
	},
	{
		"href": "http://fastcashmoneyplus.biz",
		"description": "Act NOW by joining scores of people jsut like yourself who have realized staggering amounts of wealth by using the FastCashMoneyPlus (TM)'s patented wealth-accumulation platform"
	},
	{
		"href": "https://friendworld.social",
		"description": "Make new friends today"
	},
	{
		"href": "https://friendworld.social",
		"description": "Join the social media platform that EVERYONE has been talking about!"
	},
	{
		"href": "https://0ms.co/sexydating",
		"description": "Find sexy singles in your area!"
	},
	{
		"href": "https://finsexy.com",
		"description": "Send $$ to SEXY FINDOMS"
	},
	{
		"href": "https://smarthome.steviep.xyz",
		"description": "Automate your home TODAY!"
	},
	{
		"href": "https://smarthome.steviep.xyz",
		"description": "Learn the secret mining technique the government doesn't want you to know about"
	},
	{
		"href": "http://whereisyourgodnow.xyz",
		"description": "Are you tired well you don't have to be!! Get more energy with this weird trick!!"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/content/ads.json
// module id = 137
// module chunks = 0